module.exports = __webpack_public_path__ + "img/bk.ddcbb50c.png";